module.exports = __webpack_public_path__ + "static/media/avg-goal.a774a01d.svg";